import _isString from "lodash-es/isString";
import React from "react";
import { connect } from "alt-react";
import AccountActions from "actions/AccountActions";
import AccountStore from "stores/AccountStore";
import SettingsStore from "stores/SettingsStore";
import SettingsActions from "actions/SettingsActions";
import ZfApi from "react-foundation-apps/src/utils/foundation-api";
import SendModal from "../Modal/SendModal";
import GatewaysModal from "../Modal/GatewaysModal";
import GatewayStore from "stores/GatewayStore";
import Icon from "../Icon/Icon";
import counterpart from "counterpart";
import WalletDb from "stores/WalletDb";
import WalletUnlockStore from "stores/WalletUnlockStore";
import WalletUnlockActions from "actions/WalletUnlockActions";
import WalletManagerStore from "stores/WalletManagerStore";
import cnames from "classnames";
import TotalBalanceValue from "../Utility/TotalBalanceValue";
import ReactTooltip from "react-tooltip";
import { Apis } from "bitsharesjs-ws";
import AccountImage from "../Account/AccountImage";
import { ChainStore } from "bitsharesjs";
import { List } from "immutable";
import DropDownMenu from "./HeaderDropdown";
import { withRouter } from "react-router-dom";
import { Notification } from "bitshares-ui-style-guide";
import { setLocalStorageType, isPersistantType } from "lib/common/localStorage";
import HeaderMenuItem from "./HeaderMenuItem";
import DividerMenuItem from "./DividerMenuItem";
import MenuItemType from "./MenuItemType";
import MenuDataStructure from "./MenuDataStructure";
import { getDefaultMarket } from "branding";

class Header extends React.Component {
  constructor(props) {
    super();
    this.state = {
      active: props.location.pathname,
      accountsListDropdownActive: false,
      dropdownActive: false,
      isGatewaysModalVisible: false
    };
    this._accountNotificationActiveKeys = [];
    this.unlisten = null;
    this._toggleAccountDropdownMenu = this._toggleAccountDropdownMenu.bind(this);
    this._toggleDropdownMenu = this._toggleDropdownMenu.bind(this);
    this._closeDropdown = this._closeDropdown.bind(this);
    this._closeMenuDropdown = this._closeMenuDropdown.bind(this);
    this._closeAccountsListDropdown = this._closeAccountsListDropdown.bind(this);
    this._closeAccountNotifications = this._closeAccountNotifications.bind(this);
    this.showGatewaysModal = this.showGatewaysModal.bind(this);
    this.hideGatewaysModal = this.hideGatewaysModal.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);
  }

  showGatewaysModal() {
    this.setState({
      isGatewaysModalVisible: true
    });
  }

  hideGatewaysModal() {
    console.log("hideGatewaysModal called");
    this.setState({
      isGatewaysModalVisible: false
    });
  }

  UNSAFE_componentWillMount() {
    this.unlisten = this.props.history.listen(newState => {
      if (this.unlisten && this.state.active !== newState.pathname) {
        this.setState({
          active: newState.pathname
        });
      }
    });
  }

  componentDidMount() {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 1250);
    document.body.addEventListener("click", this.onBodyClick, {
      capture: false,
      passive: true
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }

    document.body.removeEventListener("click", this.onBodyClick);
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (np.passwordLogin !== this.props.passwordLogin && this.state.active.includes("/settings/")) {
      this.props.history.push("/settings/general");
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.myActiveAccounts !== this.props.myActiveAccounts || nextProps.currentAccount !== this.props.currentAccount || nextProps.passwordLogin !== this.props.passwordLogin || nextProps.locked !== this.props.locked || nextProps.current_wallet !== this.props.current_wallet || nextProps.lastMarket !== this.props.lastMarket || nextProps.starredAccounts !== this.props.starredAccounts || nextProps.currentLocale !== this.props.currentLocale || nextState.active !== this.state.active || nextState.hiddenAssets !== this.props.hiddenAssets || nextState.dropdownActive !== this.state.dropdownActive || nextState.accountsListDropdownActive !== this.state.accountsListDropdownActive || nextProps.height !== this.props.height || nextProps.location.pathname !== this.props.location.pathname;
  }

  _showSend(e) {
    e.preventDefault();
    if (this.send_modal) this.send_modal.show();

    this._closeDropdown();
  }

  _triggerMenu(e) {
    e.preventDefault();
    ZfApi.publish("mobile-menu", "toggle");
  }

  _toggleLock(e) {
    e.preventDefault();

    if (WalletDb.isLocked()) {
      WalletUnlockActions.unlock().then(() => {
        AccountActions.tryToSetCurrentAccount();
      }).catch(() => {});
    } else {
      WalletUnlockActions.lock();

      if (!WalletUnlockStore.getState().rememberMe) {
        if (!isPersistantType()) {
          setLocalStorageType("persistant");
        }

        AccountActions.setPasswordAccount(null);
        AccountStore.tryToSetCurrentAccount();
      }
    }

    this._closeDropdown();

    this._closeAccountNotifications();
  }

  _onNavigate(route, e) {
    e.preventDefault(); // Set Accounts Tab as active tab

    if (route == "/accounts") {
      SettingsActions.changeViewSetting({
        dashboardEntry: "accounts"
      });
    }

    this.props.history.push(route);

    this._closeDropdown();
  }

  _closeAccountsListDropdown() {
    if (this.state.accountsListDropdownActive) {
      this.setState({
        accountsListDropdownActive: false
      });
    }
  }

  _closeMenuDropdown() {
    if (this.state.dropdownActive) {
      this.setState({
        dropdownActive: false
      });
    }
  }

  _closeDropdown() {
    this._closeMenuDropdown();

    this._closeAccountsListDropdown();
  }

  _onGoBack(e) {
    e.preventDefault();
    window.history.back();
  }

  _onGoForward(e) {
    e.preventDefault();
    window.history.forward();
  }

  _accountClickHandler(account_name, e) {
    e.preventDefault();
    ZfApi.publish("account_drop_down", "close");

    if (account_name !== this.props.currentAccount) {
      AccountActions.setCurrentAccount.defer(account_name);
      const key = `account-notification-${Date.now()}`;
      Notification.success({
        message: counterpart.translate("header.account_notify", {
          account: account_name
        }),
        key,
        onClose: () => {
          // Remove key of notification from notificationKeys array after close
          this._accountNotificationActiveKeys = this._accountNotificationActiveKeys.filter(el => el !== key);
        }
      });

      this._accountNotificationActiveKeys.push(key);

      this._closeDropdown();
    }
  }

  _toggleAccountDropdownMenu() {
    // prevent state toggling if user cannot have multiple accounts
    const hasLocalWallet = !!WalletDb.getWallet();
    if (!hasLocalWallet) return false;

    this._closeAccountNotifications();

    this.setState({
      accountsListDropdownActive: !this.state.accountsListDropdownActive
    });
  }

  _toggleDropdownMenu() {
    this.setState({
      dropdownActive: !this.state.dropdownActive
    });

    this._closeAccountNotifications();
  }

  _closeAccountNotifications() {
    this._accountNotificationActiveKeys.map(key => Notification.close(key));

    this._accountNotificationActiveKeys = [];
  }

  onBodyClick(e) {
    let el = e.target;
    let insideMenuDropdown = false;
    let insideAccountDropdown = false;

    do {
      if (el.classList && el.classList.contains("account-dropdown-wrapper")) {
        insideAccountDropdown = true;
        break;
      }

      if (el.classList && el.classList.contains("menu-dropdown-wrapper")) {
        insideMenuDropdown = true;
        break;
      }
    } while (el = el.parentNode);

    if (!insideAccountDropdown) this._closeAccountsListDropdown();

    if (!insideMenuDropdown) {
      this._closeMenuDropdown();
    }
  }

  render() {
    let {
      active
    } = this.state;
    let {
      currentAccount,
      starredAccounts,
      passwordLogin,
      passwordAccount,
      height
    } = this.props;
    let tradingAccounts = AccountStore.getMyAccounts();
    let maxHeight = Math.max(40, height - 67 - 36) + "px";
    const a = ChainStore.getAccount(currentAccount);
    const showAccountLinks = !!a;
    const isMyAccount = !a ? false : AccountStore.isMyAccount(a) || passwordLogin && currentAccount === passwordAccount;
    const enableDepositWithdraw = !!a && Apis.instance() && Apis.instance().chain_id && Apis.instance().chain_id.substr(0, 8) === "4018d784";

    if (starredAccounts.size) {
      for (let i = tradingAccounts.length - 1; i >= 0; i--) {
        if (!starredAccounts.has(tradingAccounts[i])) {
          tradingAccounts.splice(i, 1);
        }
      }

      starredAccounts.forEach(account => {
        if (tradingAccounts.indexOf(account.name) === -1) {
          tradingAccounts.push(account.name);
        }
      });
    }

    let myAccounts = AccountStore.getMyAccounts();
    let myAccountCount = myAccounts.length;
    let walletBalance = myAccounts.length && this.props.currentAccount ? /*#__PURE__*/React.createElement("div", {
      className: "total-value",
      onClick: this._toggleAccountDropdownMenu
    }, /*#__PURE__*/React.createElement(TotalBalanceValue.AccountWrapper, {
      hiddenAssets: this.props.hiddenAssets,
      accounts: List([this.props.currentAccount]),
      noTip: true,
      style: {
        minHeight: 15
      }
    })) : null;
    let createAccountLink = myAccountCount === 0 ? true : null;
    let tradeUrl = this.props.lastMarket ? `/market/${this.props.lastMarket}` : "/market/" + getDefaultMarket(); // Account selector: Only active inside the exchange

    let account_display_name, accountsList;

    if (currentAccount) {
      account_display_name = currentAccount.length > 20 ? `${currentAccount.slice(0, 20)}..` : currentAccount;

      if (tradingAccounts.indexOf(currentAccount) < 0 && isMyAccount) {
        tradingAccounts.push(currentAccount);
      }

      if (tradingAccounts.length >= 1) {
        accountsList = tradingAccounts.sort().filter(name => name !== currentAccount).map(name => {
          return /*#__PURE__*/React.createElement("li", {
            key: name,
            className: cnames({
              active: active.replace("/account/", "").indexOf(name) === 0
            }),
            onClick: this._accountClickHandler.bind(this, name)
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              paddingTop: 0
            },
            className: "table-cell"
          }, /*#__PURE__*/React.createElement(AccountImage, {
            style: {
              position: "relative",
              top: 4
            },
            size: {
              height: 20,
              width: 20
            },
            account: name
          })), /*#__PURE__*/React.createElement("div", {
            className: "table-cell",
            style: {
              paddingLeft: 10
            }
          }, /*#__PURE__*/React.createElement("a", {
            className: "text lower-case" + (name === account_display_name ? " current-account" : "")
          }, name)));
        });
      }
    }

    let hamburger = this.state.dropdownActive ? /*#__PURE__*/React.createElement(Icon, {
      className: "icon-18px",
      name: "hamburger-x",
      title: "icons.hamburger_x"
    }) : /*#__PURE__*/React.createElement(Icon, {
      className: "icon-18px",
      name: "hamburger",
      title: "icons.hamburger"
    });
    const hasLocalWallet = !!WalletDb.getWallet();
    let clickHandlers = {
      showSend: this._showSend.bind(this),
      showGatewaysModal: this.showGatewaysModal.bind(this)
    };
    let renderingProps = {
      currentAccount: currentAccount,
      tradeUrl: tradeUrl,
      createAccountLink: createAccountLink
    };
    let menuDataStructure = MenuDataStructure.getData(clickHandlers, renderingProps);
    return /*#__PURE__*/React.createElement("div", {
      className: "header-container",
      style: {
        minHeight: "64px",
        paddingLeft: "1rem"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "header menu-group primary",
      style: {
        flexWrap: "nowrap",
        justifyContent: "none"
      }
    }, /*#__PURE__*/React.createElement("ul", {
      className: "menu-bar"
    }, menuDataStructure.map((menuItem, index) => {
      switch (menuItem.inHeaderBehavior) {
        case MenuItemType.Always:
        case MenuItemType.Dynamic:
          // Convert pure path to click handler
          let clickHandler = _isString(menuItem.target) ? this._onNavigate.bind(this, menuItem.target) : menuItem.target;
          return /*#__PURE__*/React.createElement(HeaderMenuItem, {
            key: index,
            currentPath: active,
            includePattern: menuItem.includePattern,
            excludePattern: menuItem.excludePattern,
            target: clickHandler,
            hideClassName: menuItem.hideClassName,
            icon: menuItem.icon,
            text: menuItem.text,
            behavior: menuItem.inHeaderBehavior,
            hidden: menuItem.hidden
          });

        case MenuItemType.Divider:
          return /*#__PURE__*/React.createElement(DividerMenuItem, {
            key: index,
            additionalClassName: menuItem.additionalClassName,
            hidden: menuItem.hidden
          });
      }
    })))), /*#__PURE__*/React.createElement("div", {
      className: "app-menu",
      style: {
        right: 0,
        position: "absolute"
      }
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this._toggleDropdownMenu,
      className: cnames("menu-dropdown-wrapper dropdown-wrapper", {
        active: this.state.dropdownActive
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "hamburger"
    }, hamburger), /*#__PURE__*/React.createElement(DropDownMenu, {
      dropdownActive: this.state.dropdownActive,
      toggleLock: this._toggleLock.bind(this),
      maxHeight: maxHeight,
      locked: this.props.locked,
      active: active,
      passwordLogin: passwordLogin,
      onNavigate: this._onNavigate.bind(this),
      isMyAccount: isMyAccount,
      contacts: this.props.contacts,
      showAccountLinks: showAccountLinks,
      tradeUrl: tradeUrl,
      currentAccount: currentAccount,
      enableDepositWithdraw: enableDepositWithdraw,
      showSend: this._showSend.bind(this),
      showGatewaysModal: this.showGatewaysModal.bind(this)
    }))), /*#__PURE__*/React.createElement(SendModal, {
      id: "send_modal_header",
      refCallback: e => {
        if (e) this.send_modal = e;
      },
      from_name: currentAccount
    }), /*#__PURE__*/React.createElement(GatewaysModal, {
      visible: this.state.isGatewaysModalVisible,
      hideModal: this.hideGatewaysModal,
      ref: "gateways_modal",
      modalId: "gateways_modal",
      account: currentAccount,
      backedCoins: this.props.backedCoins
    }));
  }

}

Header = connect(Header, {
  listenTo() {
    return [AccountStore, WalletUnlockStore, WalletManagerStore, SettingsStore, GatewayStore];
  },

  getProps() {
    const chainID = Apis.instance().chain_id;
    return {
      backedCoins: GatewayStore.getState().backedCoins,
      myActiveAccounts: AccountStore.getState().myActiveAccounts,
      currentAccount: AccountStore.getState().currentAccount || AccountStore.getState().passwordAccount,
      passwordAccount: AccountStore.getState().passwordAccount,
      locked: WalletUnlockStore.getState().locked,
      current_wallet: WalletManagerStore.getState().current_wallet,
      lastMarket: SettingsStore.getState().viewSettings.get(`lastMarket${chainID ? "_" + chainID.substr(0, 8) : ""}`),
      starredAccounts: AccountStore.getState().starredAccounts,
      passwordLogin: SettingsStore.getState().settings.get("passwordLogin"),
      currentLocale: SettingsStore.getState().settings.get("locale"),
      hiddenAssets: SettingsStore.getState().hiddenAssets,
      settings: SettingsStore.getState().settings,
      locales: SettingsStore.getState().defaults.locale,
      contacts: AccountStore.getState().accountContacts
    };
  }

});
export default withRouter(Header);